'use client';

import { useEffect, useRef, useState } from 'react';

// button controlling the overlay via Invoker Commands API
export default function SiteHeaderToggler({ siteHeaderOverlayId = '', togglerText = '', className = '' }) {
  const dialogRef = useRef(null);
  const [togglerCommand, setTogglerCommand] = useState('show-modal');
  // Invoker Commands API is unsupported in Safari < 26 / older browsers.
  // When absent the command/commandfor attributes do nothing, so we fall back to manual dialog control.
  const [supportsCommand, setSupportsCommand] = useState(true);

  useEffect(() => {
    setSupportsCommand(typeof HTMLButtonElement !== 'undefined' && 'command' in HTMLButtonElement.prototype);

    dialogRef.current = document.querySelector(`#${siteHeaderOverlayId}`);
    const handleToggle = (e) => {
      setTogglerCommand(`${e.newState === 'open' ? 'close' : 'show-modal'}`);
    };
    dialogRef.current?.addEventListener('toggle', handleToggle);

    return () => dialogRef.current?.removeEventListener('toggle', handleToggle);
  }, [siteHeaderOverlayId]);

  const handleClick = () => {
    const dialog = dialogRef.current;

    // Fallback toggle for browsers without Invoker Commands support.
    if (!supportsCommand && dialog) {
      if (dialog.open) {
        dialog.close();
      } else {
        dialog.showModal();
      }
    }

    if (togglerCommand === 'close') {
      document.querySelectorAll('.SiteHeader__Overlay[open]').forEach((dialog) => {
        if (dialog.id !== siteHeaderOverlayId) {
          dialog.close();
        }
      });
    }
  };

  return (
    <button
      type="button"
      {...(supportsCommand ? { commandfor: siteHeaderOverlayId, command: togglerCommand } : {})}
      className={`SiteHeader__toggler ${className}`}
      aria-label={togglerText}
      onClick={handleClick}
    >
      <span className={`SiteHeader__toggler__text`}>{togglerText}</span>
      <span className={`SiteHeader__toggler__icon`}>
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
  );
}
